import styled from 'styled-components';
import media from '../../../../../styled/media';

export const Posts = styled.div`
  display: grid;
  grid-gap: 22px;
  margin-bottom: 22px;
  ${media.tablet`
    grid-template-columns: 1fr 1fr;
  `}
  ${media.PC`
    grid-template-columns: 1fr 1fr 1fr;
  `}
`;

export const Button = styled.button`
  display: block;
  margin: 22px auto;
  background: none;
  padding: 0 20px;
  height: 44px;
  text-transform: uppercase;
  border: 1px solid #000;
  &:hover {
    color: #cb2027;
    border-color: #cb2027;
  }
`;
